import React, { useEffect } from 'react';
import { useAppDispatch, useAppSelector } from '../../app/hooks';
import {
  adminSignOut,
  applicantSignOut,
  AuthenticateApplicantAsync,
  selectAuth
} from '../../features/authentication/authSlice';
import ApplicantLogin from '../../features/authentication/ApplicantLogin';
import { Outlet, useNavigate } from 'react-router-dom';
import cacheKeys from '../cacheKeys';
import { AppBar, Box, Button, CircularProgress, Toolbar, Typography } from '@mui/material';
import {
  clearAttempt,
  fetchApplicantAttemptAsync,
  selectAttempts
} from '../../features/applicant/TestView/attemptSlice';
import Timer from './Timer';

const ApplicantWrapper = () => {
  const authState = useAppSelector(selectAuth);
  const attemptState = useAppSelector(selectAttempts);
  const dispatch = useAppDispatch();
  const navigate = useNavigate();

  useEffect(() => {
    dispatch(adminSignOut());
    const cachedCode = sessionStorage.getItem(cacheKeys.applicantCode);
    if (cachedCode) {
      dispatch(AuthenticateApplicantAsync(cachedCode));
    }
  }, []);

  useEffect(() => {
    if (authState.applicant) {
      dispatch(fetchApplicantAttemptAsync())
        .unwrap()
        .catch(() => navigate('/'));
    }
  }, [authState.applicant]);

  if ((!authState.applicant && !authState.loading) || authState.attemptingLogin) {
    return <ApplicantLogin />;
  }

  const handleSignOut = () => {
    dispatch(applicantSignOut());
    dispatch(clearAttempt());
    navigate('/');
  };
  return (
    <Box sx={{ display: 'flex' }}>
      <AppBar position="fixed" sx={{ zIndex: (theme) => theme.zIndex.drawer + 1 }}>
        <Toolbar sx={{ display: 'flex', justifyContent: 'space-between' }}>
          <Typography>Analytics Test</Typography>
          {attemptState.attempt && <Timer />}
          <Button color="inherit" onClick={handleSignOut}>
            Sign Out
          </Button>
        </Toolbar>
      </AppBar>
      <Box minWidth="100%">
        <Toolbar />
        {authState.loading ? <CircularProgress /> : <Outlet />}
      </Box>
    </Box>
  );
};

export default ApplicantWrapper;
